import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addSupplier } from "../../redux/actions/supplier/addSupplierAction";
import UploadSupplierExcel from "./UploadSupplierExcel";
import styles from "./AddSup.module.css";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";

const AddSup = ({
	onSuccess = null,
	inModal = false,
	onCancel = null,
	prefilledName = '',
	mode = 'add',
	supplierId = null,
	prefillData = null,
}) => {
	const dispatch = useDispatch();
	const { Title } = Typography;

	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		if (inModal && form) {
			// Add mode: keep old behavior (only name prefill)
			if (mode === 'add' && prefilledName) {
				form.setFieldsValue({ name: prefilledName });
				return;
			}

			// Edit mode: prefill full form values
			if (mode === 'edit' && prefillData) {
				form.setFieldsValue({
					name: prefillData.name ?? '',
					phone: prefillData.phone ?? '',
					address: prefillData.address ?? '',
					opening_balance: prefillData.opening_balance ?? 0,
					opening_balance_date: prefillData.opening_balance_date
						? moment(prefillData.opening_balance_date)
						: null,
				});
			}
		}
	}, [inModal, prefilledName, mode, supplierId, prefillData, form]);

	const onClick = () => setLoading(true);
	const showCancel = Boolean(onCancel);

	const onFinish = async (values) => {
		try {
			const payload = {
				...values,
				opening_balance: values.opening_balance != null ? values.opening_balance : 0,
				opening_balance_date: values.opening_balance_date ? values.opening_balance_date.format("YYYY-MM-DD") : undefined,
			};

			// Edit mode: call update endpoint and close modal
			if (inModal && mode === 'edit' && supplierId != null) {
				await axios({
					method: 'put',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json;charset=UTF-8',
					},
					url: `supplier/${supplierId}`,
					data: { ...payload },
				});

				toast.success('Supplier Updated');
				setLoading(false);
				form.resetFields();
				if (onSuccess) onSuccess(null);
				return;
			}

			// Add mode
			const resp = await dispatch(addSupplier(payload));
			if (resp.message === "success") {
				setLoading(false);
				form.resetFields();
				if (inModal && onSuccess) onSuccess(resp.data || null);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.log(error.message);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoading(false);
		console.log("Failed:", errorInfo);
	};

	const formContent = (
		<Form
			form={form}
			name='basic'
			labelCol={{ span: inModal ? 6 : 7 }}
			labelWrap
			wrapperCol={{ span: inModal ? 18 : 16 }}
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
		>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Name'
				name='name'
				rules={[{ required: true, message: "Please input supplier name!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Phone'
				name='phone'
				
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Address'
				name='address'
			
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Opening Balance'
				name='opening_balance'
			>
				<InputNumber min={0} style={{ width: "100%" }} placeholder="0" />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label={
					<span>
						Date
						<Tooltip title="Opening Balance Date">
							<InfoCircleOutlined style={{ marginLeft: 4, color: "#999", cursor: "help" }} />
						</Tooltip>
					</span>
				}
				name='opening_balance_date'
			>
				<DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: inModal ? 0 : "10px" }}
				className={!inModal ? styles.addSupplierBtnContainer : undefined}
				wrapperCol={inModal ? { span: 18, offset: 0 } : undefined}
			>
				{inModal ? (
					<div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
						<Button
							loading={loading}
							onClick={onClick}
							htmlType='submit'
							shape='round'
							style={{
								backgroundColor: "#52c41a",
								borderColor: "#52c41a",
								color: "#fff",
								display: "flex",
								justifyContent: "center",
								textAlign: "center",
							}}
							block={!showCancel}
						>
							{mode === 'edit' ? 'Update Supplier' : 'Add Supplier'}
						</Button>
						{onCancel && (
							<Button type="primary" danger shape="round" onClick={onCancel}>
								Cancel
							</Button>
						)}
					</div>
				) : (
					<Button loading={loading} onClick={onClick} type='primary' htmlType='submit' shape='round'>
						Add Supplier
					</Button>
				)}
			</Form.Item>
		</Form>
	);

	if (inModal) return formContent;

	return (
		<Fragment>
			<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false}>
						<Title level={4} className="text-center" style={{ backgroundColor: '#dadada', padding: '10px', margin: '0 !important' }}>
							Add Supplier
						</Title>
						{formContent}
					</Card>
				</Col>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false} className={styles.importCsvCard}>
						<Title level={4} className='m-2 text-center'>Import From Excel</Title>
						<UploadSupplierExcel onSuccess={onSuccess} />
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AddSup;
